/**
 * KAP-300 fix-forward — underline serialization.
 *
 * Markdown has no native underline syntax. The default `@lexical/markdown`
 * `TRANSFORMERS` set silently drops underline format when serializing — so
 * a user who clicked the toolbar Underline button (or typed Cmd+U once that
 * shortcut lands) would see the format apply in the editor, send the
 * message, and watch the underline vanish on the wire.
 *
 * We adopt the CriticMarkup `++text++` convention (the most common
 * community choice for underline in markdown extensions) as a Lexical
 * `TextFormatTransformer`. The `++` tag does not collide with anything in
 * the default `TRANSFORMERS` set (`**`, `*`, `_`, `~~`, `` ` ``), so it
 * round-trips cleanly both inside the Lexical editor (draft load) and on
 * the wire payload.
 *
 * Recipients render via `MarkdownRenderer`, which preprocesses `++text++`
 * spans into `<u>...</u>` HTML before invoking `react-markdown` with
 * `rehype-raw`. Combined formats like bold+italic+underline serialize as
 * `++***combo***++` and the HTML preprocess yields `<u>***combo***</u>`,
 * which react-markdown then parses as `<u><em><strong>combo</strong></em></u>`.
 */
export const UNDERLINE_TRANSFORMER = {
  format: ['underline'],
  tag: '++',
  type: 'text-format'
};
